module.exports = __webpack_public_path__ + "static/pattern1-a45de65bbd26cf30ea613b450cd3c03a.svg";